import { ReactNode } from 'react'

import { PageTemplateContent } from 'app/common/templates-next/page-template'
import { BannerContent } from 'app/common/components-next/banner'

import styles from './BannerContainer.scss'

type Props = {
  children: ReactNode
  bannerPlaceID?: string
  hide?: boolean
}

export const BannerContainer = ({ children, bannerPlaceID, hide }: Props) => {
  return (
    <PageTemplateContent horizontalLayoutTop skipPadding>
      <div className={styles.content}>{children}</div>

      {bannerPlaceID && !hide && (
        <BannerContent refreshOnMount className={styles.bannerContent} placeId={bannerPlaceID} />
      )}
    </PageTemplateContent>
  )
}
